export const checkGoUser = (owner: string) => {
  return owner !== 'Amazon';
};

export function extractUserId(input: string): string | null {
  const match = input.match(/:(\d+)$/);
  if (match && match[1]) {
    return match[1];
  }
  return null;
}
